<template>
	<div class="mainRouterView in" style="background-color: #e5eaf2">
        <div class="floor">
            <div class="title">资料下载</div>
            <div class="floor_c">
                <div class="down_img"><img src="../static/images/index/download.png" alt="图标"></div>
                <ul>
                    <li>
                        <a class="right" href="https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&ch=&tn=baiduerr&bar=&wd=%E8%B0%B7%E6%AD%8C%E6%B5%8F%E8%A7%88%E5%99%A8" target="_blank">下载谷歌浏览器<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                    <li>
                        <a href="http://se.360.cn/" target="_blank">下载360浏览器<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="downloadFile('secSignSoftware')">下载凯特信安电子签章软件<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="downloadFile('resetSecSign')">如何正确卸载重装凯特信安<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="downloadFile('secSignDoc')">智慧服务平台使用的正确姿势<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="downloadFile('secSignIntro')">下载电子签章操作手册<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click="downloadFile('settlement')">结算信息填报有关事项2016<span class="a_right">【<i class="down_i"></i>点击下载】</span></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="floor"  style="width: 37%">
            <div class="title">各方责任主体监管信息搜索平台</div>
            <div class="floor_c">
                <div class="floor_cont" style="float: left" @click="doneResPublic=true">
                    <div class="img"><img src="../static/images/index/ze1.png" alt="项目考评结果公示书"></div>
                    <div class="img_h"><img src="../static/images/index/ze1_h.png" alt="项目考评结果公示书"></div>
                    <span class="font">项目考评结果<br>公示书</span>
                </div>
                <div class="floor_cont" style="float: right" @click="doneResNotice=true">
                    <div class="img"><img src="../static/images/index/ze2.png" alt="项目考评结果告知书"></div>
                    <div class="img_h"><img src="../static/images/index/ze2_h.png" alt="项目考评结果告知书"></div>
                    <span class="font">项目考评结果<br>告知书</span>
                </div>
                <div class="floor_cont" style="float: left" @click="showResPublic=true">
                    <div class="img"><img src="../static/images/index/ze3.png" alt="施工企业考评结果公示书"></div>
                    <div class="img_h"><img src="../static/images/index/ze3_h.png" alt="施工企业考评结果公示书"></div>
                    <span class="font">施工企业考评结果<br>公示书</span>
                </div>
                <div class="floor_cont" style="float: right" @click="showResNotice=true">
                    <div class="img"><img src="../static/images/index/ze4.png" alt="施工企业考评结果告知书"></div>
                    <div class="img_h"><img src="../static/images/index/ze4_h.png" alt="施工企业考评结果告知书"></div>
                    <span class="font">施工企业考评结果<br>告知书</span>
                </div>
            </div>
        </div>
        <div class="floor" style="width: 11%;text-align: center">
            <div class="title">客服QQ群</div>
            <div class="floor_c" style="text-align: center">
                <p style="font-size: 14px;color: #838587;text-indent: 0px;margin-top: 60px">客服一群</p>
                <p style="font-size: 16px;color: #f88b0a;text-indent: 0px;">610519150</p>
                <p style="font-size: 14px;color: #838587;text-indent: 0px;">客服二群</p>
                <p style="font-size: 16px;color: #f88b0a;text-indent: 0px;">679859213</p>
            </div>
        </div>
        <div class="floor" style="height: 238px">
            <div class="title">学习园地</div>
            <div class="floor_c learn">
                <ul>
                    <li v-for="(item,index) in learn" v-if="index < 5"><a :href="item.url" target="_blank"><span class="cont">{{item.title}}</span><span class="a_right">{{item.publishTime}}</span></a></li>
                </ul>
            </div>
        </div>
        <div class="floor" style="height: 238px">
            <div class="title">海迈资讯</div>
            <div class="floor_c">
                <ul>
                    <!--<li><a target="_blank" href="http://bim.hymake.cn/#/index">2018年度福建省建筑信息模型（BIM）技能大赛报名中<span class="a_right">2018-08-13</span></a></li>-->
                </ul>
            </div>
        </div>
        <div style="clear: both;"></div>
        <!--<div style="margin-top: 15px;width: 99%">-->
            <!--<el-carousel :interval="5000" arrow="always" class="carousel" :class="{ active: hide_menu }">-->
                <!--<el-carousel-item>-->
                    <!--<a href="http://check.hmzan.com/#/login" target="_blank"><img src="../static/images/Ad/banner1.png" alt="海迈企业在线检查平台" title="海迈企业在线检查平台"></a>-->
                <!--</el-carousel-item>-->
                <!--<el-carousel-item>-->
                    <!--<a href="http://www.efileyun.com" target="_blank"><img src="../static/images/Ad/banner2.jpg" alt="海迈电子档案平台" title="海迈电子档案平台"></a>-->
                <!--</el-carousel-item>-->
                <!--<el-carousel-item>-->
                    <!--<a href="http://xy.hmzan.com/sys/home/homepage" target="_blank"><img src="../static/images/Ad/banner4.png" alt="海迈建筑施工企业信用管理平台" title="海迈建筑施工企业信用管理平台"></a>-->
                <!--</el-carousel-item>-->
            <!--</el-carousel>-->
        <!--</div>-->
		<el-dialog title="责令改正通知单" size="large" v-if="showCorrectNotice" :visible.sync="showCorrectNotice">
			<correct-notice v-if="showCorrectNotice"></correct-notice>
		</el-dialog>
		<!-- 记分告知单、合同履约评价单 -->
		<el-dialog :title="listTile" size="large" v-if="showList" :visible.sync="showList">
			<infor-list v-if="showList" :title="listTile"></infor-list>
		</el-dialog>
		<el-dialog title="项目考评结果公示书" size="large" v-if="doneResPublic" :visible.sync="doneResPublic">
			<done-result-publicity v-if="doneResPublic" :isIndex="true"></done-result-publicity>
		</el-dialog>
		<el-dialog title="项目考评结果告知书" size="large" v-if="doneResNotice" :visible.sync="doneResNotice">
			<done-result-inform v-if="doneResNotice" :isIndex="true"></done-result-inform>
		</el-dialog>
		<el-dialog title="施工企业考评结果公式书" size="large" v-if="showResPublic" :visible.sync="showResPublic">
			<result-public-notice v-if="showResPublic" :isIndex="true"></result-public-notice>
		</el-dialog>
		<el-dialog title="施工企业考评结果告知书" size="large" v-if="showResNotice" :visible.sync="showResNotice">
			<result-notice v-if="showResNotice" :isIndex="true"></result-notice>
		</el-dialog>
		<el-dialog title="监督部门两个工作事项清单(链接跳转)" size="large" v-if="showProjectList" :visible.sync="showProjectList">
			<!-- <project-list v-if="showProjectList" :isIndex="true"></project-list> -->
		</el-dialog>
        <el-dialog title="系统升级维护通知" v-if="showTips" size="tiny" :visible.sync="showTips" style="height: 370px">
            <p style="color: #000;font-size: 18px;">&emsp;&emsp;项目监管系统将于7月4日（周六）00：00至7月5日（周日）20：00进行升级维护，届时系统将暂停使用，请各用户提前安排好相关工作，由此给您带来的不便，敬请谅解。</p>
            <p style="color: #000;text-align: right;font-size: 18px;">2020年7月2日</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showTips = false">确 定</el-button>
            </span>
        </el-dialog>
	</div>
</template>
<script>
import { parse_entity } from "@/tool/parse.js"
import openByPost from "@/tool/openByPost.js"
import { API_ProjectMaterials, API_StaticFile, API_CONST,API_SecSeal } from "@/api/api.js"
// LTAIJXZyYx9Qttzd	 SLUGGw7gJmyAiJaV7MgELbbgddE8qA
import correctNotice from "@/components/pages/homepage/correctNotice.vue"
import inforList from "@/components/pages/homepage/inforList.vue"

import doneResultPublicity from "@/components/pages/safetyCheck/cstProject/doneResultPublicity.vue"
import doneResultInform from "@/components/pages/safetyCheck/cstProject/doneResultInform.vue"
import resultPublicNotice from "@/components/pages/safetyCheck/cstEnterprise/resultPublicNotice.vue"
import resultNotice from "@/components/pages/safetyCheck/cstEnterprise/resultNotice.vue"
export default {
	name: "index",
    props:["hide_menu"],
	data() {
		return {
			listTile: '',
			showCorrectNotice: false,
			showList: false,
			doneResPublic: false,
			doneResNotice: false,
			showResPublic: false,
			showResNotice: false,
			showProjectList: false,
            learn:[],
            swiperOption: {
                //slidesPerView: 1,
                slidesPerView: "auto",
                autoplay:false,
                observer:true,
                observeParents:true,
                clickable: true,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                },
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                },
            },
            showTips: false
		}
	},
	mounted() {
        if (localStorage.clazzes == null) {
            let me = this;
            let url = API_CONST.learnUrl;
            $.ajax({
                type: "GET",
                url: url,
                data:"",
                dataType: "json",
                success: function(res){
                    let str = JSON.stringify(res._embedded.clazzes)
                    localStorage.clazzes = str;
                    me.learn = res._embedded.clazzes;
                }
            });
        } else {
            this.learn = JSON.parse(localStorage.clazzes);
        }
//        if (new Date().getTime() > 1593950400000) { // 7月5号 18:00 不弹窗
//          this.showTips = false
//        } else {
//          this.showTips = true
//        }
	},
	methods: {
		downloadFile(name) {
			window.open(API_StaticFile[name]);
		},
	},
	components: { correctNotice, inforList, doneResultPublicity, doneResultInform, resultPublicNotice, resultNotice }
}
</script>
<style>
.el-message-box__message p{
	font-size: 14px;
}
input.is-danger,
textarea.is-danger,
select.is-danger
{
	border: 1px solid red;
}

.is-danger.tip {
	color: red;
	font-style: italic;
	display: table-cell;
}
.mainRouterView.in{
    padding-left: 15px;
}
.mainRouterView .floor{
    background-color: #fff;
    padding: 0 25px;
    border-radius: 4px;
    font-family: 微软雅黑;
    width: 49%;
    margin-top: 15px;
    height: 341px;
    float: left;
    margin-right: 15px;
    box-shadow: 0px 2px 19.6px 0.4px rgba(53,137,240,0.1);
}
.mainRouterView .floor:nth-child(3),.mainRouterView .floor:nth-child(5){
    margin-right: 0px;
}
.mainRouterView .floor .title{
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 18px;
    color: #333;
}
.mainRouterView .floor .floor_c{
    border-top: 1px solid #f5f7fa;
}
.mainRouterView .floor .floor_c ul{
    padding: 0px;
    margin: 0px;
}
.mainRouterView .floor:first-child .floor_c ul{
    margin-left: 260px;
}
.mainRouterView .floor .floor_c ul li{
    line-height: 35px;
    height: 35px;
}
.mainRouterView .floor .floor_c ul li a{
    width: 100%;
    color: #666;
    font-size: 14px;
}
.mainRouterView .floor .floor_c ul li a:link{
    text-decoration: none;
}
.mainRouterView .floor .floor_c ul li:hover a{
    color: #3589f0;
    text-decoration: none;
}
.mainRouterView .floor .floor_c ul li .a_right{
    float: right;
    font-size: 14px;
}
.down_img{
    float: left;
    margin: 53px 30px;
}
.mainRouterView .floor .floor_c ul li:hover a .down_i{
    background-image: url("../static/images/index/down_ra.png");
}
.down_i{
    background-image: url("../static/images/index/down_r.png");
    background-repeat: no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
}
.floor_cont{
    width: 48%;
    box-shadow: 0px 2px 19.6px 0.4px rgba(53,137,240,0.1);
    margin-top: 20px;
    height: 109px;
    line-height: 109px;
    cursor: pointer;
}
.floor_cont:hover{
    background-color: #e9f3ff;
    box-shadow: 0px 2px 4.9px 0.1px rgba(91,128,165,0.15);
}
.floor_cont .img{
    display: inline-block;
    width: 38%;
    text-align: center;
    position: relative;
}
.floor_cont .img img,.floor_cont:hover .img_h img{
    max-width: 100%;
}
.floor_cont .img_h{
    width: 38%;
    text-align: center;
    position: relative;
    display: none;
}
.floor_cont:hover .img_h{
    display: inline-block;
}
.floor_cont:hover .img{
    display: none;
}
.floor_cont .img:after,.floor_cont:hover .img_h:after{
    width: 1px;
    height: 36px;
    background-color: #eeeff1;
    display: inline-block;
    content: "";
    vertical-align: middle;
    position: absolute;
    right: 0px;
    top: 36px;
}
.floor_cont:hover .img_h:after{
    background-color: #fff;
}
.floor_cont .font{
    font-size: 16px;
    color: #666;
    line-height: 25px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
}
.floor_cont:hover .font{
    color: #3589f0;
}
.swiper img{
    width: 100%;
}
.swiper .swiper-slide{
    width: 100%;
}
.carousel .el-carousel__container{
    height: 160px;
}
.carousel .el-carousel__button{
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.carousel.active .el-carousel__item img{
    width: 100%;
}
.learn ul li a .cont{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    display: inline-block;
    width: 88%;
}
@media screen and (max-width: 1750px) {
    .floor_cont .font{
        font-size: 14px;
    }
    .learn ul li a .cont{
        width: 85%;
    }
}
@media screen and (max-width: 1600px) {
    .floor_cont .img,.floor_cont:hover .img_h{
        display: none;
    }
    .floor_cont .font{
        font-size: 16px;
        text-align: center;
        margin-left: 0px;
        width: 100%;
    }
    .mainRouterView .floor:first-child .floor_c ul{
        margin-left: 0px;
    }
    .down_img{
        display: none;
    }
    .mainRouterView .floor .title{
        font-size: 16px;
    }
}
@media screen and (max-width: 1450px){
    .learn ul li a .cont{
        width: 81%;
    }
}
</style>




// WEBPACK FOOTER //
// index.vue?7cdecc57